import React from "react";
import { ArrowRight, ArrowUpRight } from "@phosphor-icons/react";
import { PHONE_DISPLAY, PHONE_HREF } from "@/components/SiteHeader";

const BONE = "#F5F4F0";
const CHAR = "#1C1A17";
const TERRA = "#C84B31";

const NetworkLink = ({ href, children, testid }) => (
  <a href={href} data-testid={testid} className="group inline-flex items-center gap-2 text-[#F5F4F0]/85 hover:text-[#F5F4F0]">
    <span className="inline-block h-[6px] w-4" style={{ backgroundColor: TERRA }} />
    {children}
    <ArrowUpRight size={12} weight="bold" className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </a>
);

// Full site footer with NAP block. Shared by / and /service-area.
export const SiteFooter = ({ quoteHref = "#quote" }) => (
  <footer style={{ backgroundColor: CHAR, color: BONE }}>
    <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-5 py-14 md:grid-cols-12 md:px-10">
      <div className="md:col-span-5">
        <div className="flex items-center gap-3">
          <div className="grid h-9 w-9 place-items-center rounded-sm" style={{ backgroundColor: TERRA }}>
            <span className="font-display text-[15px] font-black leading-none text-[#F5F4F0]">H</span>
          </div>
          <div className="font-display text-lg font-black tracking-tight">HCOB Property Services</div>
        </div>
        <p className="mt-4 max-w-sm text-[13px] leading-relaxed text-[#F5F4F0]/65">
          A project management company connecting customers with trusted service professionals across Baltimore and all of Maryland.
        </p>
        <p className="mt-5 font-display text-[13px] font-bold italic" style={{ color: TERRA }}>
          By the Community. For the Community.
        </p>
      </div>

      <div className="md:col-span-3">
        <div className="font-mono-label mb-4 text-[10px] tracking-[0.28em] text-[#F5F4F0]/50">Contact</div>
        <a href={PHONE_HREF} className="block font-display text-2xl font-black hover:opacity-75" style={{ color: BONE }} data-testid="footer-nap-phone">
          {PHONE_DISPLAY}
        </a>
        <address className="mt-3 space-y-1 not-italic text-[12px] text-[#F5F4F0]/60" data-testid="footer-nap">
          <div className="font-bold text-[#F5F4F0]/80">HCOB Property Services</div>
          <div data-testid="footer-nap-hours">Open 24 hours · 7 days a week</div>
          <div data-testid="footer-nap-area">
            Baltimore, MD ·{" "}
            <a href="/service-area" className="underline underline-offset-2 hover:text-[#F5F4F0]" data-testid="footer-service-area-link">
              Serving all of Maryland
            </a>
          </div>
          <a href="https://hcobnetwork.com" className="inline-flex min-h-[32px] items-center font-bold text-[#F5F4F0]/80 hover:text-[#F5F4F0]" data-testid="footer-nap-website">
            hcobnetwork.com
          </a>
        </address>
        <a href={quoteHref} className="mt-5 inline-flex items-center gap-1 text-[13px] font-bold hover:opacity-75" style={{ color: TERRA }}>
          Request a quote <ArrowRight size={14} />
        </a>
      </div>

      <div className="md:col-span-4">
        <div className="font-mono-label mb-4 text-[10px] tracking-[0.28em] text-[#F5F4F0]/50">Also on the network</div>
        <div className="flex flex-col gap-3 text-[13px]">
          <NetworkLink href="/work" testid="footer-contractors-link">For contractors — join the crew</NetworkLink>
          <NetworkLink href="/vas">Refer leads · earn commissions</NetworkLink>
        </div>
      </div>
    </div>

    <div className="border-t border-[#F5F4F0]/10">
      <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-between gap-3 px-5 py-5 text-[11px] text-[#F5F4F0]/55 md:px-10">
        <div>© {new Date().getFullYear()} HCOB Property Services · Gwynn Oak, MD · hcobnetwork.com</div>
        <div className="flex flex-wrap gap-x-5 gap-y-1">
          <a href="/privacy.html" data-testid="footer-privacy-link" className="hover:text-[#F5F4F0]">Privacy</a>
          <a href="/terms.html" data-testid="footer-terms-link" className="hover:text-[#F5F4F0]">Terms</a>
          <a href="/sms-terms.html" data-testid="footer-sms-terms-link" className="hover:text-[#F5F4F0]">SMS Terms</a>
        </div>
      </div>
    </div>
  </footer>
);
